export default "__VITE_PUBLIC_ASSET__b0f1e5bf__"